export default "__VITE_ASSET__667069ec__"